import { useEffect, useState } from "react";

const MixSlide = (props) => {
  const {
    mix,
    image,
    index,
    mixesData,
    latestMixes,
    activeIndex,
    setDrawerMix,
    setDrawerOpen,
    setPlayingMix,
    setPlayerOpen,
  } = props;

  const [coverPosition, setCoverPosition] = useState("prev");

  useEffect(() => {
    if (activeIndex > index) {
      setCoverPosition("prev");
    } else if (activeIndex < index) {
      setCoverPosition("next");
    } else if (activeIndex === index) {
      setCoverPosition("active");
    }
    // console.log(image);
    
  }, [activeIndex]);

  const [match, setMatch] = useState(null);
  useEffect(()=>{
   const newMatch = latestMixes.find(obj => obj.artistName === mix.title);
   
    setMatch(newMatch);
    
  })

  if(match){
  return (
    <section className={`home__slide-wrapper`}>
      <button
        className={`home__cover-wrapper 
            ${coverPosition}`}
            style={{backgroundImage: `url(${image})`}}
        onClick={(e) => {
          setDrawerMix(match);
          setDrawerOpen(true);
        }}
      >
        <div className="home__color" />
      </button>
      <div
        className={`home__buttons-wrapper ${
          activeIndex === index ? "active" : ""
        }`}
      >
        <button
          className={`ra__button playlist__more-info`}
            onClick={(e) => {
          setDrawerMix(match);
          setDrawerOpen(true);
        }}
        >
          More Info <span className="ra__arrow">&#8599;</span>
        </button>
        <button
          className="ra__button playlist__listen"
          onClick={(e) => {
            e.stopPropagation();
            setPlayingMix(match);
            setPlayerOpen(true);
          }}
        >
          Listen
        </button>
      </div>
    </section>
  );
  }

};

export default MixSlide;
